<template>
  <div>
    <div class="tab-content">
      <TabList />
      <TabBreadcrumb />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TabBreadcrumb from './TabBreadcrumb'
import TabList from './TabList'

export default defineComponent({
  name: 'ContainerTabMenu',
  components: {
    TabBreadcrumb,
    TabList
  }
})
</script>

<style lang='scss' scoped>
.tab-content {
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #F6F6F6;
  border: $border-grey;
  box-sizing: border-box;
}
</style>
